export default __webpack_public_path__ + "static/media/default.edf4d14c.png";